import MP4Box from "mp4box";

class Fmp4Player {
  constructor(mediaDataSource, config) {
    this._mediaElement = null
    this._mediaDataSource = mediaDataSource
    this._config = config
    this._mp4Box = null;
    this._mp4initSegs = null;
    this._mp4info = null;
    this._nextFileStart = 0;
    this._videoSourceBuffer = null;
    this._queue = [];
    this._firstMessage = true;
    this._prePos = 0;
    this._errorFlag = false;
    this._websocket = null;
  }

  attachMediaElement(mediaElement) {
    this._mediaElement = mediaElement;
    this._websocket = new WebSocket(this._mediaDataSource.url);
    this._websocket.binaryType = 'arraybuffer';
    this._websocket.addEventListener('message', this.handleMessage.bind(this));

  }

  handleMessage(e) {
    // 不处理非ArrayBuffer数据
    if (!(e.data instanceof ArrayBuffer)) {
      return;
    }

    if (this._firstMessage) {
      // 初始化MSE 目前默认初始化
      this._mediaSource = new MediaSource();
      this._mediaElement.src = URL.createObjectURL(this._mediaSource);
      this._mediaSource.addEventListener('sourceopen', this.mediaSourceOpen.bind(this));
      this._firstMessage = false;
    }

    try {
      this._queue.push(e.data);
      this._appendBuffer()
    } catch (error) {
      console.error(error)
    }
  }

  _appendBuffer() {
    if (this._queue.length) {
      if (this._videoSourceBuffer && !this._videoSourceBuffer.updating) {
        const segment = this._queue.shift();
        try {
          this._videoSourceBuffer.appendBuffer(segment);
        } catch (err) {
          console.error('append: ', err);
          this._websocket.close();
        }
      }
  
    }
  }

  detachMediaElement() {
    if (this._mediaElement) {
      this._videoSourceBuffer.removeEventListener('error', this.sourceBufferUpdateError.bind(this));
      this._videoSourceBuffer.removeEventListener('updateend', this.sourceBufferUpdateEnd.bind(this));
      this._mediaElement = null; 
    }

    if (this._mediaSource) {
      this._mediaSource.removeSourceBuffer(this._videoSourceBuffer);
      this._mediaSource = null;
    }

    if (this._websocket) {
      this._websocket.close();
      this._websocket = null;
    }
  }
  mediaSourceOpen() {
    // 备注：此处目前默认采用H264编码，后续需要根据WebSocket首条Message来修改编码
    this._videoSourceBuffer = this._mediaSource.addSourceBuffer('video/mp4; codecs="avc1.64002A"');
    this._videoSourceBuffer.addEventListener('updateend', this.sourceBufferUpdateEnd.bind(this))
    this._videoSourceBuffer.addEventListener('abort', function () {console.log('abort');});
    this._videoSourceBuffer.addEventListener('error', this.sourceBufferUpdateError.bind(this));
  }

  sourceBufferUpdateError() {
    this._errorFlag = true;
  }

  sourceBufferUpdateEnd() {}
}


export default Fmp4Player;